import React from "react";
import banner from "@/assets/aapleSarkarBanner.png"
import useLanguageContext from "@/hooks/useLanguageContext";
import { useTranslation } from "react-i18next";

type GovernmentWebsite = {
    id: string | number;
    name: string;
    ministryOrDept?: string;
    description: string;
    url: string;
    tag?: string;
};

const websitesEN: GovernmentWebsite[] = [
    {
        id: 1,
        name: "Aaple Sarkar",
        ministryOrDept:
            "Maharashtra Right to Public Services Act, Government of Maharashtra",
        description:
            "Aaple Sarkar is the official online portal of the Maharashtra government (India) for citizens to access over 400 government services, like applying for certificates (caste, land records), licenses, and welfare schemes, all from one platform, offering transparency, time-bound delivery, and an online appeal system under the Right to Public Services Act",
        url: "https://aaplesarkar.mahaonline.gov.in/en",
        tag: "State Portal",
    },
];

const websitesMR: GovernmentWebsite[] = [
    {
        id: 1,
        name: "आपले सरकार",
        ministryOrDept:
            "महाराष्ट्र लोकसेवा हक्क कायदा, महाराष्ट्र सरकार",
        description:
            "आपल सरकार हे महाराष्ट्र सरकारचे (भारत) अधिकृत ऑनलाइन पोर्टल आहे जे नागरिकांना एकाच व्यासपीठावरून ४०० हून अधिक सरकारी सेवा जसे की प्रमाणपत्रांसाठी अर्ज करणे (जात, जमिनीच्या नोंदी), परवाने आणि कल्याणकारी योजना उपलब्ध करून देते, जे पारदर्शकता, कालबद्ध वितरण आणि सार्वजनिक सेवा हक्क कायद्याअंतर्गत ऑनलाइन अपील प्रणाली प्रदान करते.",
        url: "https://aaplesarkar.mahaonline.gov.in/en",
        tag: "राज्य पोर्टल",
    },
];

const GovernmentWebsitesPage: React.FC = () => {

    const { lang } = useLanguageContext();
    const { t: _ } = useTranslation();

    const data = lang == "en" ? websitesEN : websitesMR

    return (
        <main className="px-4 py-10 md:px-8 lg:px-16">
            <section className="mx-auto flex flex-col gap-8">
                {/* Page header */}
                <header className="space-y4">
                    <img src={banner} alt="Aaple Sarkar Banner" className="rounded-md" />
                </header>

                <div className="grid gap-8">
                    {data.map((site) => (
                        <article
                            key={site.id}
                            className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-100/70 transition hover:-translate-y-0.5 hover:shadow-md dark:border-slate-700 dark:bg-slate-900"
                        >
                            <div className="mb-3 flex items-start justify-between gap-3">
                                <div>
                                    <h2 className="text-base font-semibold text-slate-900 dark:text-slate-50">
                                        {site.name}
                                    </h2>
                                    {site.ministryOrDept && (
                                        <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">
                                            {site.ministryOrDept}
                                        </p>
                                    )}
                                </div>

                                {site.tag && (
                                    <span className="inline-flex flex-none items-center rounded-full bg-emerald-50 px-2.5 py-1 text-[0.65rem] font-medium text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300">
                                        {site.tag}
                                    </span>
                                )}
                            </div>

                            <p className="flex-1 text-sm leading-relaxed text-slate-700 dark:text-slate-200">
                                {site.description}
                            </p>

                            <div className="mt-5 flex items-center justify-between gap-2">
                                <a
                                    href={site.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-1/12 inline-flex items-center justify-center rounded-lg border border-emerald-600 bg-emerald-600 px-3.5 py-2 text-xs font-medium text-white transition hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 focus:ring-offset-slate-50 dark:focus:ring-offset-slate-900"
                                >
                                    {_("visit_website")}{" "}
                                    <span className="ml-2 text-[0.65rem]">↗</span>
                                </a>
                                <span className="break-all text-[0.7rem] text-slate-500 dark:text-slate-400">
                                    {site.url}
                                </span>
                            </div>
                        </article>
                    ))}
                </div>
            </section>
        </main>
    );
};

export default GovernmentWebsitesPage;
